import { DefaultResponseDTO, PagedResponseDTO } from '../../constants';
import { getRegistrationRequest } from '../../registrationApi/api';
import { CountryDTO } from './countries.dto';
export const getCountriesRequest = (country: string): Promise<DefaultResponseDTO<CountryDTO[]>> => {
  return getRegistrationRequest<PagedResponseDTO<CountryDTO[]>>(`${country}`);
};
